import * as React from "react"
import { Link } from "gatsby"
import * as styles from "./styles/index.css"

const links = [
  { to: "/support", children: "Support" },
  { to: "/dashboard/login", children: "Log In" },
]

export default function MetaNav() {
  return (
    <div className={styles.metaNav}>
      {links.map(link => (
        <Link key={link.to} className={styles.metaNavItem} {...link} />
      ))}
    </div>
  )
}
